// @flow
import React from 'react';
import t from './../i18n/I18n';
import CredentialsModal from './../modals/userinput/CredentialsModal';
import AuthenticationController from './../controllers/AuthenticationController';
import Authenticator from './../protocol/Authenticator';
import Authenticator2 from './Authenticator2';
import { NULL_OAUTH_REALM } from './AuthMechanism';
import CreateNewUser from './../queries/user/CreateNewUser';
import ViewUtil from './../ViewUtil';

function createPopUp():Element {
  const div = document.createElement('div');
  document.body.appendChild(div);
  return div;
}

function closePopUp(div: Element) {
  unmountComponentAtNode(div);
  document.body.removeChild(div);
}

function dismissPopUp(err: ?Error = null) {
  closePopUp(document.getElementById('CredentialsModal').parentElement);
  if (err) throw err;
}

// TODO: This is Work-in-Progress. The rendering of this UI flow is not working.

export default function showLoginPopup(actionName:string) {

  const performSignIn = (resolve, username: string, password: string):Promise => {
    // Authenticate with the username and password
    return AuthenticationController.signin(username, password)
    .then(() => {
      dismissPopUp();
      if (window.gs.isLogged) {
        ViewUtil.removeArg('collection');
        resolve(true);
      } else {
        resolve(false);
      }
    });
  };

  const obtainPasswordAndSignIn = (resolve, username: string, verificationPassword: ?string = null) => {
    render(CredentialsModal.getCredentialsModal({
      onCancel: () => {
        dismissPopUp();
        resolve(false);
      },
      onSubmit: (password) => {
        let authRealm = Authenticator2.getAuthRealmForExternalUserFromWindowsArgument();
        if (!authRealm) {
          authRealm = Authenticator2.isBasicMechanismAvailable()
            ? Authenticator2.findBasicAuthType()[0].getAuthRealm()
            : null;
        }
        if (!authRealm) {
          authRealm = NULL_OAUTH_REALM;
        }
        Authenticator.AUTHENTICATOR_INSTANCE.authRealm = authRealm;
        return (verificationPassword ?
          // Create the user with the verification OTP received and new password input.
          CreateNewUser.createUser(username, '', '', verificationPassword, password, null, null)
          // Else empty promise to handle an existing user email for whom the verification link sending failed.
          : new Promise((onSuccess, onFailure) => onSuccess(true))
        )
        .then((success) => performSignIn(resolve, username, password))
        .catch(dismissPopUp);
      }
    }), createPopUp());
  };

  const obtainVerificationPasscodeAndSignIn = (resolve, username) => {
    render(CredentialsModal.getCredentialsModal({
      type: 'input',
      inputText: t('PASSCODE_SEND_CHECK_MAIL'),
      inputPlaceholder: 'E-mail verification passcode',
      submitBtnTxt: 'Next',
      onCancel: () => {
        dismissPopUp();
        resolve(false);
      },
      onSubmit: (verificationPassword) => {
        dismissPopUp();
        obtainPasswordAndSignIn(resolve, username, verificationPassword);
      }
    }), createPopUp());
  };

  return new Promise(resolve => {
    render(CredentialsModal.getCredentialsModal({
      type: 'input',
      inputText: t('ACTION_REQUIRES_LOGIN', {action: actionName}),
      inputPlaceholder: 'E-mail address (or username)',
      submitBtnTxt: 'Next',
      onCancel: () => {
        dismissPopUp();
        resolve(false);
      },
      onSubmit: (username) => {
        // Send the email verification link for a new user
        CreateNewUser.sendEmailVerificationLink(username, '', '')
        .then((success) => {
          dismissPopUp();
          obtainVerificationPasscodeAndSignIn(resolve, username);
        })
        .catch(dismissPopUp);
      }
    }), createPopUp());
  });
}
